export type ProductProfile = 'HipaaLink' | 'Via3';

const rawProfile = process.env.REACT_APP_PRODUCT_PROFILE;

export const productProfile: ProductProfile = rawProfile === 'Via3' ? 'Via3' : 'HipaaLink';

export const isHipaaLink = productProfile === 'HipaaLink';
export const isVia3 = productProfile === 'Via3';
export const productName = isHipaaLink ? 'HIPAA LINK' : 'VIA3';
